import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FaTimes } from 'react-icons/fa';

const WhatsAppButton = ({ 
  phoneNumber = '+9601234567',
  message = 'Hello! I would like to know more about your packages.',
  position = 'bottom-right',
  showTooltip = true,
  tooltipText = 'Chat on WhatsApp',
  size = 'md',
  pulse = true,
  className = '',
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [showTooltipState, setShowTooltipState] = useState(showTooltip);

  // Hide tooltip after 5 seconds
  useEffect(() => {
    if (showTooltip) {
      const timer = setTimeout(() => {
        setShowTooltipState(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showTooltip]);

  // Position classes
  const positionClasses = {
    'bottom-right': 'bottom-6 right-6',
    'bottom-left': 'bottom-6 left-6',
    'top-right': 'top-6 right-6',
    'top-left': 'top-6 left-6',
  };

  // Size classes
  const sizeClasses = {
    sm: 'w-12 h-12 text-2xl',
    md: 'w-14 h-14 text-3xl',
    lg: 'w-16 h-16 text-4xl',
  };

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className={`fixed ${positionClasses[position]} z-50 ${className}`}>
      {/* Tooltip */}
      {showTooltipState && (
        <div className="absolute bottom-full right-0 mb-3 bg-gray-900 text-white text-sm px-4 py-2 rounded-lg shadow-lg whitespace-nowrap animate-fadeIn">
          {tooltipText}
          <div className="absolute bottom-0 right-4 translate-y-1/2 rotate-45 w-3 h-3 bg-gray-900"></div>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          relative flex items-center justify-center
          bg-green-500 hover:bg-green-600
          text-white rounded-full
          shadow-xl hover:shadow-2xl
          transition-all duration-300
          ${sizeClasses[size]}
          ${pulse && 'animate-pulse-slow'}
          ${isHovered ? 'scale-110' : 'scale-100'}
        `}
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp />
        
        {/* Notification badge */}
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center animate-pulse rotate-45">
          1
        </span>
      </button>
    </div>
  );
};

export default WhatsAppButton;